module.exports = __webpack_public_path__ + "img/flag.184c17ae.svg";